<template>
  <th scope="col" :class="{ 'is-num': column.numeric }" :aria-sort="ariaSortValue" :title="column.description || null">
    <span class="pi-th">
      <button type="button" class="pi-sort" :disabled="disabled" @click="$emit('sort', column)">
        {{ column.label }}<span class="pi-sort__caret" aria-hidden="true">{{ caret }}</span>
      </button>
      <pi-definition-tooltip v-if="info" :info-key="info" :label="column.label" :align="column.numeric ? 'right' : 'left'"/>
    </span>
  </th>
</template>

<script>
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import { ariaSort } from "./piQuery.js";
import { sortCaret } from "./piTable.js";

export default {
  name: "pi-sort-th",
  components: { piDefinitionTooltip },
  props: {
    column: { type: Object, required: true },
    state: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
    infoKey: { type: String, default: "" },
  },
  computed: {
    ariaSortValue() {
      return ariaSort(this.state, this.column.key);
    },
    caret() {
      return sortCaret(this.state, this.column.key);
    },
    info() {
      return this.infoKey || this.column.infoKey || "";
    },
  },
};
</script>

<style src="./pi.css"></style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piSortTh.vue